import { Component, OnInit, inject, input, linkedSignal, viewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { ScriptService } from '@services/script.service';
import { map, Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-aw-coord-picker',
    templateUrl: 'coord-picker.component.html',
    styleUrls: ['./coord-picker.component.scss'],
    imports: [GoogleMapsModule, MatButtonModule, MatIconModule, AsyncPipe],
})
export class CoordinatePickerComponent implements OnInit {
    private scriptService = inject(ScriptService);

    readonly mapInstance = viewChild(GoogleMap);
    mapPosition = {
        lat: 56.6874856,
        lng: 16.2927703,
    };

    readonly height = input('300px');
    readonly latitude = input<AbstractControl>(undefined);
    readonly longitude = input<AbstractControl>(undefined);
    readonly hasMarker = input(false);
    readonly hasMarkerState = linkedSignal(this.hasMarker);

    mapLoaded$: Observable<boolean>;

    zoom = 7;

    ngOnInit() {
        this.mapLoaded$ = this.scriptService.load(this.scriptService.availableScripts.googlemaps).pipe(map(() => true));

        const latitude = this.latitude();
        const longitude = this.longitude();
        if (latitude.value && longitude.value) {
            this.mapPosition = {
                lat: latitude.value,
                lng: longitude.value,
            };

            this.hasMarkerState.set(true);
            this.zoom = 13;
        }
    }

    mapReady(_e) {
        // this.mapInstance = e;
    }

    markerDragged(e: google.maps.MapMouseEvent) {
        this.latitude().setValue(e.latLng.lat());
        this.longitude().setValue(e.latLng.lng());
    }

    toggleMarker() {
        const hasMarker = this.hasMarkerState();
        if (!hasMarker) {
            this.latitude().setValue(this.mapInstance().getCenter().lat());
            this.longitude().setValue(this.mapInstance().getCenter().lng());
        } else {
            this.latitude().setValue(null);
            this.longitude().setValue(null);
        }

        this.hasMarkerState.set(!hasMarker);
    }
}
